import React from "react";
import { Grid } from "@mui/material";
import ExpandableSearch from "../ExpandableSearch/ExpandableSearch";
import SalesManageSession from "../NavbarActionsSection/NavbarActions";
import styles from "./styles.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTES, SYSTEM_VIEW, KEYBOARD_KEYS, EVENTS } from "const";
import { eventsEmitter } from "utils/events";
import * as TerminalHelper from "helpers/TermialHelper";
import ShopsHelper from "helpers/ShopsHelper";
import SearchContext from "context/SearchContext";

function MainNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { triggerSearchAction, setSearchTerm } = React.useContext(SearchContext);

  React.useEffect(() => {
    setSearchTerm("");
  }, [location.pathname, setSearchTerm]);

  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === KEYBOARD_KEYS.F1 || e.key === KEYBOARD_KEYS.SLASH) {
        // If it's /, we only want to trigger search if not already typing in an input
        if (e.key === KEYBOARD_KEYS.SLASH && (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA")) {
          return;
        }
        e.preventDefault();
        triggerSearchAction("FOCUS_SEARCH");
      }
    };
    const unsubscribeFn = eventsEmitter.on(EVENTS.KEY_DOWN, handleKeyDown);
    return unsubscribeFn;
  }, [triggerSearchAction]);

  const isTableDashboard = location.pathname === ROUTES.TABLE_DASHBOARD;

  const terminalSettings = TerminalHelper.getTerminalSettings();
  const erpSystemView = terminalSettings?.systemType === SYSTEM_VIEW.ERP;

  const handleLogoClick = () => {
    const terminalSettings = TerminalHelper.getTerminalSettings();
    const isTableDashboardEnabled = terminalSettings?.isTableDashboardEnabled;
    const isOrderDashboardEnabled = terminalSettings?.isOrderDashboardEnabled;
    const systemType = terminalSettings?.systemType;
    const hasFullKotValidity = ShopsHelper.hasFullKotValidity(ShopsHelper.getCachedShopProfile());

    if (systemType === SYSTEM_VIEW.ERP) {
      navigate(ROUTES.ERP_DASHBOARD);
    } else if (isTableDashboardEnabled && hasFullKotValidity) {
      navigate(ROUTES.TABLE_DASHBOARD);
    } else if (isOrderDashboardEnabled) {
      navigate(ROUTES.ACTIVE_ORDERS);
    } else {
      navigate(ROUTES.SALES);
    }
  };

  return (
    <div className={styles.row}>
      <Grid className={`${styles.topRow} ${isTableDashboard ? styles.tableTopRow : ""}`}>
        <Grid className={styles.logoSection} onClick={handleLogoClick}>
          <span className={styles.head1}>Sanoft</span>
          <span className={styles.head2}>POS</span>
        </Grid>
        <Grid className={styles.actionsection}>
          <div className={styles.actionItemsWrapper}>
            {!erpSystemView && (
              <>
                <ExpandableSearch />
                <div className={styles.bar} />
              </>
            )}
            <SalesManageSession />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default MainNavbar;
